import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { ExtensionIcon } from "../assets/icons";
import ReportIndicatorItem from "./ReportIndicatorItem";
import { formatCharacterName } from "../Utils/formatReportText";

export default function ReportIndicatorList({ characters = [], loading = false, loadError = false }) {
  if (loading || loadError || characters.length === 0) {
    const message = loading
      ? "Memuat data laporan..."
      : loadError
        ? "Data laporan belum dapat dimuat."
        : "Belum ada data indikator untuk periode ini.";

    return <Text style={styles.messageText}>{message}</Text>;
  }

  return (
    <View style={styles.groups}>
      {characters.map((character) => {
        const indicators = character.indicators || [];

        return (
          <View key={character.name} style={styles.card}>
            <View style={styles.heading}>
              <View style={styles.iconTile}><ExtensionIcon width={16} height={16} /></View>
              <Text style={styles.title}>{formatCharacterName(character.name)}</Text>
            </View>
            <View style={styles.divider} />
            {indicators.length === 0 && (
              <Text style={styles.messageText}>Belum ada data indikator untuk karakter ini.</Text>
            )}
            {indicators.map((item, index) => (
              <ReportIndicatorItem
                key={`${item.name}-${index}`}
                item={item}
                isLast={index === indicators.length - 1}
              />
            ))}
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  groups: { gap: 16 },
  card: { paddingHorizontal: 12, paddingTop: 11, paddingBottom: 4, borderRadius: 14, backgroundColor: "#FFFFFF", elevation: 2, shadowColor: "#34234A", shadowOpacity: 0.07, shadowRadius: 4, shadowOffset: { width: 0, height: 2 } },
  heading: { minHeight: 24, flexDirection: "row", alignItems: "center", gap: 8 },
  iconTile: { width: 20, height: 20, borderRadius: 5, backgroundColor: "#F1F1F1", alignItems: "center", justifyContent: "center" },
  title: { color: "#171717", fontFamily: "Archivo-Bold", fontSize: 12 },
  divider: { height: 1, marginTop: 10, marginBottom: 0, backgroundColor: "#EEEEEE" },
  messageText: { paddingVertical: 8, color: "#777777", fontFamily: "Archivo-Regular", fontSize: 11 },
});